import React, { useState, useEffect } from "react";
import QuizLandingTemplate from "../../../templates/QuizLandingTemplate";
import remoteQuizService from "../../../services/RemoteQuizService";
import { ClimbingBoxLoader } from "react-spinners";
import { Black } from "../../../components/theme/colors";

const AttachmentStylesLanding = () => {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchConfig = async () => {
      const remoteConfig = await remoteQuizService.getQuizConfig(
        "attachment-styles"
      );
      setConfig(remoteConfig);
      setLoading(false);
    };
    fetchConfig();
  }, []);

  if (loading || !config) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          backgroundColor: Black,
        }}
      >
        <ClimbingBoxLoader color="#ffffff" size={15} />
      </div>
    );
  }

  return (
    <QuizLandingTemplate
      quizConfig={config}
      specialHeaderConfig={config.specialHeaderConfig}
      hasNativePlatformLogic={config.hasNativePlatformLogic}
    />
  );
};

export default AttachmentStylesLanding;
